<template>
    <CadastroPadrao :cabecalho="state.cabecalho" :linhas="state.linhas" :url="state.url" :titulo="state.titulo"
        :limparInput="limparInput" :objeto="state.objetoAuxiliar">
        <template v-slot:ficha>
            <div class="row p-2">
                <label for="" class="col lbl">
                    Código
                </label>
                <div class="col inp">
                    <input type="text" class="form-control" v-model="state.objetoAuxiliar.id" disabled>
                </div>
            </div>
            <div class="row p-2">
                <label for="" class="col lbl">
                    Nome
                </label>
                <div class="col inp">
                    <input type="text" class="form-control" v-model="state.objetoAuxiliar.nome" placeholder="Nome">
                </div>
            </div>
            <div class="row p-2">
                <label for="" class="col lbl">
                    Ativo
                </label>
                <div class="col inp">
                    <input type="checkbox" class="form-check-input" v-model="state.objetoAuxiliar.ativo">
                </div>
            </div>
            <div class="row p-2">
                <label for="" class="col lbl">
                    Cadastro
                </label>
                <div class="col inp">
                    <select v-model="state.objetoAuxiliar.sigla">
                        <option v-for="(l, index) in state.lstConselhosSigla" :key="index" :value="l"> {{ l }} - {{
                            state.lstConselhosDescricao[index] }} </option>
                    </select>
                </div>
            </div>
            <div class="row p-2">
                <label for="" class="col lbl">
                    Número
                </label>
                <div class="col inp">
                    <input type="number" v-model="state.objetoAuxiliar.numero">
                </div>
            </div>
            <div class="row p-2">
                <label for="" class="col lbl">
                    Unidade Federativa
                </label>
                <div class="col inp">
                    <select v-model="state.objetoAuxiliar.uf">
                        <option v-for="(l, index) in state.lstEstadoSigla" :key="index" :value="l"> {{ l }} - {{
                            state.lstEstadoDescricao[index] }} </option>
                    </select>
                </div>
            </div>
            <div class="row p-2">
                <label for="" class="col lbl">
                    CBOS
                </label>
                <div class="col inp">
                    <input type="number" v-model="state.objetoAuxiliar.cbos">
                </div>
            </div>
        </template>
    </CadastroPadrao>
</template>

<script setup>
import CadastroPadrao from '@/components/CadastroPadrao.vue';
import store from '@/store/store';
import { reactive, onMounted, computed } from 'vue';

const state = reactive({
    cabecalho: ['Código', 'Nome', 'Cadastro', 'Número', 'UF'],
    linhas: ['id', 'nome', 'sigla', 'numero', 'uf'],
    url: "Profissional",
    titulo: "Cadastro de Profissional",
    objetoAuxiliar: {
        ativo: Boolean()
    },
    lstEstadoSigla: ["AC", "AL", "AP", "AM", "BA", "CE", "DF", "ES", "GO", "MA", "MT", "MS", "MG", "PA", "PB", "PR", "PE", "PI", "RJ", "RN", "RS", "RO", "RR", "SC", "SP", "SE", "TO"],
    lstEstadoDescricao: ["Acre", "Alagoas", "Amapá", "Amazonas", "Bahia", "Ceará", "Distrito Federal", "Espírito Santo", "Goiás", "Maranhão", "Mato Grosso", "Mato Grosso do Sul", "Minas Gerais", "Pará", "Paraíba", "Paraná", "Pernambuco", "Piauí", "Rio de Janeiro", "Rio Grande do Norte", "Rio Grande do Sul", "Rondônia", "Roraima", "Santa Catarina", "São Paulo", "Sergipe", "Tocantins"],
    lstConselhosSigla: ["CREA", "CAU", "CRBIO", "CRMV ", "CRM", "CRP", "CRF", "CRO", "Crefito", "Crefono", "CRQ", "CRN", "CREF", "COREN", "Outros"],
    lstConselhosDescricao: [" - Conselho Regional dos Engenheiros e Agrônomos",
        " - Conselho dos Arquitetos e Urbanistas",
        " - Conselho Regional de Biologia",
        " - Conselho Regional de Medicina Veterinária",
        " - Conselho Regional de Medicina",
        " - Conselho Regional de Psicologia",
        " - Conselho Regional de Farmácia",
        " - Conselho Regional de Odontologia",
        " - Conselho Regional Fisioterapia Terapia Ocupacional",
        " - Conselho Regional de Fonoaudiologia",
        " - Conselho Regional de Química",
        " - Conselho Regional de Nutrição",
        " - Conselho Regional de Educação Física",
        " - Conselho Regional de Enfermagem"],
});
async function limparInput(pObj) {
    if (pObj) {
        state.objetoAuxiliar = pObj;
    } else {
        state.objetoAuxiliar = {};
        let maiorId = 0;
        setor.value.forEach(s => {
            if (maiorId < s.id) {
                maiorId = s.id;
            }
        });
        state.objetoAuxiliar.id = maiorId + 1;
        state.objetoAuxiliar.ativo = true;
        state.objetoAuxiliar.dtInclusao = new Date();
        state.objetoAuxiliar.dtAlteracao = new Date();
    }
}
const setor = computed(() => {
    return store.state.setores;
});
</script>

<style scoped>
.lbl {
    max-width: 35%;
    line-height: 35px;
}
</style>